import cn from '@integrations/classnames'
import { configuration } from 'mmfintech-backend-api'
import { getCurrencyImageUrl } from 'mmfintech-commons'
import styles from './CurrencyIcon.module.scss'

interface Props {
  currency: string
  size?: string
  circle?: boolean
  className?: string
}

function CurrencyIcon({ currency, size, circle, className }: Props) {
  return (
    <div
      className={cn(
        styles['currency-icon-wrapper'],
        'currency-icon-wrapper',
        { [styles['circle']]: circle, circle },
        className
      )}
      {...(size ? { style: { width: size, height: size } } : {})}
    >
      <img src={`${configuration.getBaseUrl()}${getCurrencyImageUrl(currency, 'svg')}`} alt='' />
    </div>
  )
}

export default CurrencyIcon
